/**
 * A client's contacts are kept in English (operator, 2026-10-12: "in clients in
 * Contacts all data must be in English language only no other language"):
 * English letters, digits 0–9, spaces and the symbols on an English keyboard —
 * printable ASCII, the API's own rule (`UpsertClientContactDto`).
 */
const ENGLISH_TEXT = /^[\x20-\x7E]*$/;

/**
 * What a pasted value brings that nobody can see — the direction marks an
 * Arabic screen puts around a phone number, a zero-width or a non-breaking
 * space — is not a language: the marks are dropped and every space becomes a
 * plain one, as the API does before it checks.
 */
export const plainText = (value: string) => value.replace(/\p{Cf}/gu, '').replace(/\p{Zs}/gu, ' ');

/** Whether a value is in English as it will be saved. Nothing at all is. */
export const isEnglish = (value: string | null | undefined) => !value || ENGLISH_TEXT.test(plainText(value));
